import { useEffect, useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import "./Členové.css";
import { MapaCR } from "@ceskastranaasocialu/komponenty";
import clenoveTitle from "../../images/Titles/web_clenove_nadpis.webp";
import clenove from "./data.js"
import Neni from '../../images/logo-white.webp'

const jePredsednictvo = (r) => r[6] != null;

function RadekClena({ r }) {
    const [rozbaleno, setRozbaleno] = useState(false);
    const [přetéká, setPřetéká] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (el) setPřetéká(el.scrollHeight > el.clientHeight + 1);
    }, []);

    return (
        <tr className={jePredsednictvo(r) ? "radekPredsednictvo" : ""}>
            <td className="fotka"><img src={r[0] ?? Neni} alt="" draggable="false" /></td>
            <td>{r[1]}</td>
            <td>{r[2]}</td>
            <td>{r[3]}</td>
            <td className="oMne">
                <div className="oMneWrap">
                    <div ref={ref} className={`oMneText ${rozbaleno ? "rozbaleno" : ""}`}>{r[4]}</div>
                    {(přetéká || rozbaleno) && (
                        <button type="button" className="viceMene" onClick={() => setRozbaleno((p) => !p)}>
                            {rozbaleno ? "méně" : "více"}
                        </button>
                    )}
                </div>
            </td>
            <td>{r[5]}</td>
        </tr>
    );
}

function KartaČlena({ r }) {
    const [rozbaleno, setRozbaleno] = useState(false);
    const [přetéká, setPřetéká] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const měř = () => {
            const el = ref.current;
            if (el && !rozbaleno) setPřetéká(el.scrollHeight > el.clientHeight + 1);
        };
        měř();
        window.addEventListener("resize", měř);
        return () => window.removeEventListener("resize", měř);
    }, [rozbaleno]);

    return (
        <div className={`členKarta ${jePredsednictvo(r) ? "kartaPredsednictvo" : ""}`}>
            <div className="kartaHlava">
                <img className="kartaFoto" src={r[0] ?? Neni} alt="" draggable="false" />
                <div className="kartaJmeno">
                    <span className="kartaCeleJmeno">{r[1]} {r[2]}</span>
                    <div className="kartaOdznaky">
                        {r[3] && <span className="odznakKraj">{r[3]}</span>}
                        <span className="odznakFunkce">{r[5]}</span>
                    </div>
                </div>
            </div>
            <div className="kartaOMne">
                <div ref={ref} className={`oMneText ${rozbaleno ? "rozbaleno" : ""}`}>{r[4]}</div>
                {(přetéká || rozbaleno) && (
                    <button type="button" className="kartaViceMene" onClick={() => setRozbaleno((p) => !p)}>
                        {rozbaleno ? "méně" : "více"}
                    </button>
                )}
            </div>
        </div>
    );
}

function ClenoveTabulka({ filtr }) {
    const [sloupecŘaz, setSloupecŘaz] = useState(1);
    const [sloupecVzes, setSloupecVzes] = useState(true);

    const zmenaŘazení = (col) => {
        if (sloupecŘaz === col) {
            setSloupecVzes((prev) => !prev);
        } else {
            setSloupecŘaz(col);
            setSloupecVzes(true);
        }
    };

    const filtrovani = filtr ? clenove.filter((r) => r[3] === filtr) : clenove;

    const predsednictvo = filtrovani
        .filter(jePredsednictvo)
        .sort((a, b) => a[6] - b[6]);

    const ostatni = filtrovani
        .filter((r) => !jePredsednictvo(r))
        .sort((a, b) => {
            const valA = a[sloupecŘaz] ?? "";
            const valB = b[sloupecŘaz] ?? "";
            return sloupecVzes ? valA.localeCompare(valB, "cs") : valB.localeCompare(valA, "cs");
        });

    const pole = [...predsednictvo, ...ostatni];

    const šipky = (col) => sloupecŘaz === col ? <span>{sloupecVzes ? " ▲" : " ▼"}</span> : "";

    const header = (label, col) => (
        <th onClick={() => zmenaŘazení(col)} style={{ cursor: "pointer", userSelect: "none" }}>
            {label}{šipky(col)}
        </th>
    );

    return (
        <>
            <div className="razeniMobil">
                <span className="razeniLabel">Řadit:</span>
                <button
                    type="button"
                    className="razeniJmeno"
                    onClick={() => zmenaŘazení(1)}
                >
                    Jméno {sloupecVzes ? "▲" : "▼"}
                </button>
            </div>
            <div className="členoveKarty">
                {pole.map((r) => (
                    <KartaČlena key={`${r[1]}-${r[2]}`} r={r} />
                ))}
            </div>
            <div className="členováTabulka">
            <table border="1" cellPadding="6" cellSpacing="0">
                <colgroup>
                    <col className="colFotka" />
                    <col className="colJmeno" />
                    <col className="colPrijmeni" />
                    <col className="colKraj" />
                    <col className="colOMne" />
                    <col className="colFunkce" />
                </colgroup>
                <thead>
                    <tr>
                        <th>Fotka</th>
                        {header("Jméno", 1)}
                        {header("Příjmení", 2)}
                        {header("Kraj", 3)}
                        <th>Něco málo o mne</th>
                        {header("Funkce", 5)}
                    </tr>
                </thead>
                <tbody>
                    {pole.map((r) => (
                        <RadekClena key={`${r[1]}-${r[2]}`} r={r} />
                    ))}
                </tbody>
            </table>
            </div>
        </>
    );
}

function OstatníČlenové() {
    const [vybranýKraj, setVybranýKraj] = useState(null);

    const webyKraju = {
        "Liberecký": "https://lbk.asocialove.cz",
        "Středočeský": "https://stc.asocialove.cz",
        "Jihočeský": "https://jhc.asocialove.cz"
    }

    const pocty = useMemo(() => {
        const m = {};
        for (const r of clenove) m[r[3]] = (m[r[3]] || 0) + 1;
        return m;
    }, []);

    const vybrat = (kraj) => setVybranýKraj((prev) => (prev === kraj ? null : kraj));

    const n = vybranýKraj ? pocty[vybranýKraj] || 0 : 0;
    const slovo = n === 1 ? "člen" : n >= 2 && n <= 4 ? "členové" : "členů";
    const nazevKraje = !vybranýKraj ? "" : vybranýKraj === "Praha" ? "Praha" : `${vybranýKraj} kraj`;
    const link = !vybranýKraj ? "" : webyKraju[vybranýKraj];

    return (
        <div className="ostatníČlenové">
            <MapaCR className="mapaCR" vybrano={vybranýKraj} pocty={pocty} onVybrat={vybrat} />
            {vybranýKraj && (
                <div className="krajFiltr">
                    <span className="krajChip">{nazevKraje} · {n} {slovo}</span>
                    {link && <a className="krajChip material-symbols-outlined" href={link} target="_blank" rel="noopener noreferrer">language</a>}
                    <button type="button" className="krajReset" onClick={() => setVybranýKraj(null)}>
                        ✕ zrušit filtr
                    </button>
                </div>
            )}
            <ClenoveTabulka filtr={vybranýKraj} />
        </div>
    );
}

export default function Členové() {
    return (
        <div id="membersContent">
            <Helmet>
                <title>Členové · ČSA</title>
                <meta name="description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:title" content="Členové · ČSA" />
                <meta property="og:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
                <meta property="og:url" content="https://www.asocialove.cz/clenove" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Členové · ČSA" />
                <meta name="twitter:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta name="twitter:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
            </Helmet>
            <div className="clenoveTitle">
                <img src={clenoveTitle} draggable="false" alt="" />
            </div>
            <OstatníČlenové />
        </div>
    );
}
